<template>
	<div id="app">
		<!-- <router-view /> -->
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive" />
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive" />
	</div>
</template>
<script>
import routes from '@/router/routes';

export default {
	watch: {
		$route(newData) {
			this.handleRouter(newData);
		}
	},
	created() {
		this.handleRouter(this.$route);
	},
	methods: {
		handleRouter(newData) {
			let curRouter = {};
			routes.forEach((item) => {
				if (item.path == newData.path) {
					curRouter = item;
				}
			});
			document.title = curRouter.title || '';
		}
	}
};
</script>
<style lang="less">
* {
	margin: 0;
	padding: 0;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	outline-style: none;
	list-style: none;
	line-height: 1.4;
}

html,
body {
	background-color: #ffffff !important;
}

textarea,
input {
	display: block;
	resize: none;
	outline: none;
	border: none;
	background-color: transparent;
	-webkit-appearance: none;
	appearance: none;
	border-radius: 0;
}

textarea::-webkit-input-placeholder,
input::-webkit-input-placeholder {
	color: #cbcbcb;
}

textarea::input-placeholder,
input::input-placeholder {
	color: #cbcbcb;
}

input:disabled,
textarea:disabled {
	-webkit-opacity: 1;
	opacity: 1;
}

input.placeholder_em::-webkit-input-placeholder {
	font-style: italic;
}

input.placeholder_em::input-placeholder {
	font-style: italic;
}

.wechat_scroll {
	width: 100%;
	height: 100vh;
	overflow-y: auto;
	overflow-x: hidden;
}

.page {
	width: 828px;
	min-height: 100vh;
	background-color: #ffffff;
	overflow: hidden;
}

.text_left {
	text-align: left;
}

.text_center {
	text-align: center;
}

.text_right {
	text-align: right;
}

.ellipsis1 {
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	/* 限制在两行 */
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	white-space: normal;
	/* 重置默认的white-space */
}

.ellipsis2 {
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	/* 限制在两行 */
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	white-space: normal;
	/* 重置默认的white-space */
}

.ellipsis3 {
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	/* 限制在两行 */
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	white-space: normal;
	/* 重置默认的white-space */
}

.ellipsis4 {
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 4;
	/* 限制在两行 */
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	white-space: normal;
	/* 重置默认的white-space */
}

.ellipsis5 {
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 5;
	/* 限制在两行 */
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	white-space: normal;
	/* 重置默认的white-space */
}

.notScroll {
	&::-webkit-scrollbar {
		display: none !important;
		width: 0 !important;
		height: 0 !important;
	}
	&::-webkit-scrollbar-track {
		-webkit-box-shadow: none;
		background-color: transparent;
		width: 0;
		height: 0;
		display: none !important;
	}
	&::-webkit-scrollbar-thumb {
		-webkit-box-shadow: none;
		background-color: transparent;
		display: none !important;
	}
	&::-webkit-scrollbar-button {
		background-color: transparent;
		display: none !important;
	}
	&::-webkit-scrollbar-corner {
		background: transparent;
		display: none !important;
	}
}

.scrollDiy {
	/* 强制显示滚动条 */
	&::-webkit-scrollbar {
		-webkit-appearance: none;
		width: 12px;
	}

	/* 滚动条轨道的样式 */
	&::-webkit-scrollbar-track {
		background-color: transparent;
		border-radius: 100px;
	}

	/* 滚动条的样式 */
	&::-webkit-scrollbar-thumb {
		background-color: @themeColor;
		border-radius: 100px;
	}
}

.float-button {
	width: 140px;
	// height: 152px;
	background-color: rgba(61, 205, 88, 0.8);
	border-radius: 12px;
	box-shadow: 0 0 22px 4px rgba(0, 0, 0, 0.12);
	color: #fff;
	font-weight: 400;
	font-size: 26px;
	color: #ffffff;
	line-height: 32px;
	text-align: center;
	// padding: 20px 0;

	.button {
		padding: 30px 0;
		text-align: center;
		border-bottom: 1.5px solid #fff;

		&:last-child {
			border-bottom: none;
		}
	}

	img {
		width: 41px;
		height: 44px;
		font-size: 0;
		display: inline-block;
	}
}
</style>
